import type { UseFetchOptions } from "nuxt/app"

/*
* Custom useFetch composable that uses the $api function from the plugin
* it will directly include user token in the authorization header
* and will automatically handle errors with i18n toast messages.
*
* - Example: Usage with useAPI composable (during setup)
* const { data } = await useAPI<User>("/me")
*
* - Example: Usage with fetchAPI (for imperative calls in lifecycle hooks)
* onMounted(async () => {
*   const data = await fetchAPI<Subscription>("/subscriptions/active")
* })
*
* - Example: Usage with $api directly
* const { $api } = useNuxtApp()
* const redirectURL = await $api<string>(`/subscriptions/buy`)
*/
export function useAPI<T>(
  url: string | (() => string),
  options?: UseFetchOptions<T>,
) {
  return useFetch(url, {
    ...options,
    $fetch: useNuxtApp().$api as typeof $fetch,
  })
}
